import pkdApi from 'store/api/pkd';
import { SurveyStatus } from 'utils/enum';

const dailySurveyTaskId = 1;

const handleDailySurveysResponse = ({ data }) =>
{
  return data.sort((a, b) => new Date(b.data.statusDate) - new Date(a.data.statusDate));

};
const dailySurveyApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    getDailySurveys : build.query({
      queryFn : async ({ personAccountProfileId, params = {} }, api, extraOptions, baseQuery) => {
        const result = await baseQuery({
          url    : `../v3/app/profiles/${personAccountProfileId}/participant-tasks`,
          method : 'GET',
          params : { ...params, taskId: 1 },
        });

        if (result.error) {
          return result;
        }

        const transformed = handleDailySurveysResponse(result.data);
        return { data: transformed };
      },
      providesTags           : ['DailySurveys'],
      refetchOnMountOrArgChange : true,
    }),
    createDailySurvey : build.mutation({
      query : ({ personId, startDate, endDate }) => ({
        url    : `../v3/tasks/${dailySurveyTaskId}/participant-tasks/`,
        method : 'POST',
        body   : {
          data : {
            type       : 'participant-tasks',
            attributes : {
              personId,
              startDate,
              endDate,
              status : SurveyStatus.Incomplete,
            },
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['DailySurveys'],
    }),
    createDailySurveyEntry : build.mutation({
      query : ({ personId, dailySurveyId, data }) => ({
        url    : `../v1/persons/${personId}/participant-tasks/${dailySurveyId}`,
        method : 'POST',
        body   : {
          data,
          status : SurveyStatus.Completed,
        },
        bypassCaseConverter : true,
      }),
      invalidatesTags : ['DailySurveys', 'DailySurveysCompleted'],
    }),
  }),
  overrideExisting : false,
});

export const {
  useGetDailySurveysQuery,
  useCreateDailySurveyMutation,
  useCreateDailySurveyEntryMutation,
} = dailySurveyApi;
